import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
  AUTH_ACCESS_TOKEN,
  AUTH_EMITTED_IN,
  AUTH_EXPIRES_IN,
  AUTH_PERSONA_ID,
  AUTH_REFRESH_TOKEN, AUTH_TYPE,
  GetTokensResult,
  Tokens
} from '../models';
import {LocalStorageService} from './local-storage.service';
import {ConfigService} from '../../shared';
import { RolService } from '.';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(protected http: HttpClient,
              protected localStorageService: LocalStorageService,
              protected rolService: RolService
              ) {
  }

  getAccessToken(payload: any): Observable<Tokens> {
    let headers = new HttpHeaders();
    headers = headers.set('no-authenticate', 'true');

    return this.http.post<Tokens>(
      this.getSeguroUrl('getAccessToken'),
      {...payload},
      {headers}
    ).pipe(
      map(response => {
        if (response.access_token === '') {
          throw new Error('Token vacio.');
        }
        return response;
      })
    );
  }

  login(token: string, authType: string, applicationId: string): Observable<string[]> {
    return this.http.post<{ queryResults: GetTokensResult }>(this.getCoreUrl('queryTokens'),
      {tokens: [token], authType, applicationId}
    ).pipe(map(response => {
        if (response.queryResults.success && 'personasId' in response.queryResults) {
          return response.queryResults.personasId;
        }
        return null;
      })
    );
  }


  isAccessTokenExpired(): boolean {
    let expired = false;

    const emittedIn = Number(this.localStorageService.getItem(AUTH_EMITTED_IN));
    const expiresIn = Number(this.localStorageService.getItem(AUTH_EXPIRES_IN));
    const now = Date.now();

    // Resto 20 segundos para tener una holgura de cuando se emitió el token a que llega
    if ((now - emittedIn) / 1000 > (expiresIn - 20)) {
      expired = true;
    }
    return expired;
  }

  requestAccessToken(): Observable<Tokens> {
    const refreshToken = this.localStorageService.getItem(AUTH_REFRESH_TOKEN);
    const authType = this.localStorageService.getItem(AUTH_TYPE);
    let headers = new HttpHeaders();
    headers = headers.set('no-authenticate', 'true');

    return this.http.post<Tokens>(
      this.getSeguroUrl('refreshAccessToken'),
      {
        refresh_token_in: refreshToken,
        authType
      },
      {headers}
    );
  }

  saveTokens(tokens: Tokens) {
    this.localStorageService.setItem(AUTH_ACCESS_TOKEN, tokens.access_token);
    this.localStorageService.setItem(AUTH_REFRESH_TOKEN, tokens.refresh_token);
    this.localStorageService.setItem(AUTH_EXPIRES_IN, tokens.expires_in);
    this.localStorageService.setItem(AUTH_EMITTED_IN, Date.now());
  }

  removeTokens() {
    this.localStorageService.removeItem(AUTH_ACCESS_TOKEN);
    this.localStorageService.removeItem(AUTH_ACCESS_TOKEN);
    this.localStorageService.removeItem(AUTH_REFRESH_TOKEN);
    this.localStorageService.removeItem(AUTH_EXPIRES_IN);
    this.localStorageService.removeItem(AUTH_EMITTED_IN);
  }



  logout() {
    this.localStorageService.removeItem(AUTH_PERSONA_ID);
    this.removeTokens();
    this.rolService.removeRole();
  }

    /**
   * Return url from method in Secano.
   * @param method to url.
   */
     protected getSeguroUrl(method: string): string {
      const apiSeguroUrl = ConfigService.config.apiSeguroUrl;
      return `${apiSeguroUrl}/${method}`;
    }

    /**
     * Return url from method in core.
     * @param method to url.
     */
    protected getCoreUrl(method: string): string {
      const apiSeguroUrl = ConfigService.config.apiNucleoUrl;
      return `${apiSeguroUrl}/${method}`;
    }
}
